<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-if="type === 'icon'"
        class="mr-2"
        dark
        :color="actionColor"
        @click="onClick(data)"
        v-bind="attrs"
        v-on="on"
      >
        {{ iconName }}
      </v-icon>

      <v-btn
        v-if="type === 'button'"
        :color="actionColor"
        icon
        dark
        class="text-user"
        v-bind="attrs"
        v-on="on"
        :to="path"
      >
        <v-icon>{{ iconName }}</v-icon>
      </v-btn>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
const props = {
  iconName: {
    default: "mdi-home",
    type: String,
  },
  text: {
    default: "No disponible",
    type: String,
  },
  actionColor: {
    default: "blueKonect",
    type: String,
  },
  type: {
    default: "icon",
    type: String,
  },
  path: {
    default: '',
    type: String,
  },
  data: {
    type: undefined,
  },
  onClick: Function,
};

export default {
  data: () => ({
    valueOk: false,
  }),
  methods: {},
  props: props,
};
</script>

<style scoped></style>
